import { useEffect, useState } from 'react';

/**
 * THE app's "is this a phone?" test — below `md`, `matchMedia('(max-width: 767px)')`.
 *
 * Moved here UNCHANGED on 2026-10-18 from `hooks/useOrderListLayout.js`, whose
 * other half (the Table/Cards layout choice) was then deleted with the order
 * cards. Nothing here ever depended on that half; it only lived beside it.
 *
 * No `matchMedia`, or a `matchMedia` that throws (jsdom/SSR/locked-down
 * browser), resolves to DESKTOP — never let a display preference take the page
 * down.
 */
export function isMobileOrderViewport() {
  try {
    return window.matchMedia('(max-width: 767px)').matches;
  } catch (e) {
    // No matchMedia, or it threw — treat as desktop.
    return false;
  }
}

/**
 * THE live version of `isMobileOrderViewport`, tracking the media query as it
 * changes — the phone table, swipe-to-tab and the 50-row page size all key on
 * it (`MyOrders.js`, `DepartmentOrders.js`, `Approvals.js`; each carried its
 * own inline copy until 2026-10-01). Same breakpoint and the same
 * no-`matchMedia` → desktop rule.
 */
export function useIsMobileOrderViewport() {
  const [isMobile, setIsMobile] = useState(isMobileOrderViewport);
  useEffect(() => {
    let mq;
    try { mq = window.matchMedia('(max-width: 767px)'); } catch (e) { return undefined; }
    if (!mq || !mq.addEventListener) return undefined;
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isMobile;
}
